import { render, staticRenderFns } from "./DetailNJBPage.vue?vue&type=template&id=58b6c3b2&scoped=true&"
import script from "./DetailNJBPage.vue?vue&type=script&lang=js&"
export * from "./DetailNJBPage.vue?vue&type=script&lang=js&"
import style0 from "./DetailNJBPage.vue?vue&type=style&index=0&id=58b6c3b2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58b6c3b2",
  null
  
)

export default component.exports